import type { FC } from "react";
import Star from "~/components/icons/Star";

const ReviewIcon: FC<{ rating: any }> = ({ rating }) => {
  const castedRating = rating as unknown as number;
  return (
    <>
      {[...Array(5).keys()].map((i) => (
        <span key={`review_${i}`} style={{ fontSize: "28px" }}>
          {castedRating >= i + 1 ? (
            <Star mode="full" />
          ) : castedRating === i + 0.5 ? (
            <Star mode="half" />
          ) : (
            <Star mode="empty" />
          )}
        </span>
      ))}
    </>
  );
};

export const FooterReviews: FC<{ rating: any }> = ({ rating }) => (
  <div>
    <ReviewIcon rating={rating} />
  </div>
);
